import { render, staticRenderFns } from "./outorderGroup.vue?vue&type=template&id=485c9a82&scoped=true&"
import script from "./outorderGroup.vue?vue&type=script&lang=js&"
export * from "./outorderGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485c9a82",
  null
  
)

export default component.exports